import { render, staticRenderFns } from "./staticListByCard.vue?vue&type=template&id=67f86138&"
import script from "./staticListByCard.vue?vue&type=script&lang=js&"
export * from "./staticListByCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/staticListByCard.vue"
export default component.exports